module.exports = __webpack_public_path__ + "static/media/plum_compote.42706119.png";